import { DeepPartial } from "@/types";

export const toNum = (v: unknown): number | null =>
  v !== null && v !== undefined && v !== '' ? Number(v) : null;


/**
 * 可被 AbortSignal 中断的 sleep。
 * 信号触发时 reject 一个 AbortError，调用方可通过 signal?.aborted 判断。
 */
export function abortableSleep(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException('Aborted', 'AbortError'));
      return;
    }
    const timer = setTimeout(resolve, ms);
    signal?.addEventListener('abort', () => {
      clearTimeout(timer);
      reject(new DOMException('Aborted', 'AbortError'));
    }, { once: true });
  });
}

// 检查是否为 abort 错误
export const isAbortError = (error: unknown): boolean =>
  error instanceof DOMException && error.name === 'AbortError';


// 深度合并对象，后者属性覆盖前者
type PlainObject = Record<string, unknown>;
const isPlainObject = (value: unknown): value is PlainObject =>
  Object.prototype.toString.call(value) === '[object Object]';

export const deepMerge = <T>(target: T, source: DeepPartial<T>): T => {
  if (!isPlainObject(target) || !isPlainObject(source)) {
    return source as T;
  }

  const result: PlainObject = { ...(target as PlainObject) };

  Object.keys(source).forEach((key) => {
    const sourceValue = (source as PlainObject)[key];
    if (sourceValue === undefined) return;

    const targetValue = result[key];
    if (isPlainObject(targetValue) && isPlainObject(sourceValue)) {
      result[key] = deepMerge(targetValue, sourceValue);
      return;
    }

    result[key] = sourceValue;
  });

  return result as T;
};